import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
function useBrowserIdle() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIdle = _useState2[0],
    setIsIdle = _useState2[1];
  useEffect(function () {
    var id = 0;
    if (window.requestIdleCallback) {
      id = window.requestIdleCallback(function () {
        setIsIdle(true);
      });
    } else {
      id = setTimeout(function () {
        setIsIdle(true);
      }, 1);
    }
    return function () {
      if (window.cancelIdleCallback) {
        window.cancelIdleCallback(id);
      } else {
        clearTimeout(id);
      }
    };
  }, []);
  return isIdle;
}
export default useBrowserIdle;